import type { ReactNode } from "react";

export function QuotesReferenceNumber({ children }: { children: ReactNode }) {
  return <div className="text-[14px]">{children}</div>;
}

// Inline "Change …" action link. Matches the old Cargo
// `Button size="link" regularWeight` rendering (a styled span).
